import React, { Dispatch, SetStateAction, useState, ReactNode } from 'react';

export type ClientInfo = {
  /**
   * ID of the current client
   */
  clientId: string;
  rmTranslationsEnabled: boolean;
};

export type ClientInfoContextType = [
  ClientInfo,
  Dispatch<SetStateAction<ClientInfo>>,
];

export type ClientInfoContextProviderProps = {
  children: ReactNode;
} & ClientInfo;

const ClientInfoContext = React.createContext<ClientInfoContextType>([
  {
    clientId: '',
    rmTranslationsEnabled: false,
  },
  () => {},
]);

export function ClientInfoProvider({
  clientId,
  rmTranslationsEnabled,
  children,
}: ClientInfoContextProviderProps) {
  const [clientInfo, setClientInfo] = useState({
    clientId,
    rmTranslationsEnabled,
  });
  return (
    <ClientInfoContext.Provider value={[clientInfo, setClientInfo]}>
      {children}
    </ClientInfoContext.Provider>
  );
}

export const useClientInfo = () => {
  const context = React.useContext(ClientInfoContext);

  if (context === undefined) {
    throw new Error(`useClientInfo must be used within a ClientInfoProvider`);
  }

  return context;
};
